import React from 'react';

const stringToColor = (str) => {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i); // hash * 33 + c
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
};

const RepoStructure = ({ searchRepoStructureLoading, repoStructure, currentPath, navigateToFolder, goBack, subtitle, logo, muteClusterAlerts }) => (
    <div className="card shadow-sm mb-4">

        <div className="card-body">
            <div className='d-flex flex-row align-items-baseline gap-2 mb-4'>
                {currentPath && (
                    <button className="btn d-flex align-items-center" type="button" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                    </button>
                )}
                {subtitle()}
            </div>
            {!searchRepoStructureLoading && (
                <ul className="list-group">
                {repoStructure.map((item) => (
                    item.type === 'commit_directory' && (
                    <li
                        key={item.path}
                        className="list-group-item list-group-item-action d-flex align-items-center"

                    >
                        <div className="w-25" onClick={() => navigateToFolder(item.path)} style={{ cursor: "pointer" }}>
                            {logo()}
                            {item.path.split('/').pop()}
                        </div>
                        {item.metadata && (
                                <div className="w-75 d-inline-flex gap-3 flex-row-reverse">
                                    <button className="btn btn-outline-info d-flex align-items "
                                            type="button"
                                            onClick={async () => {await muteClusterAlerts(item.metadata.cluster)}}>
                                        <i className="bi bi-volume-mute-fill  me-2"></i> Mute Alerts
                                    </button>
                                    {Object.keys(item.metadata).map((key) => (
                                        <span key={key} className={`badge  justify-content-center align-content-center`}
                                              style={{backgroundColor: stringToColor(key)}}>
                                            {key} : {item.metadata[key]}
                                        </span>
                                    ))}
                                </div>
                        )}
                    </li>
                    )))}
                </ul>
            )}
            {searchRepoStructureLoading && (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    </div>
);

export default RepoStructure;
